import { isOtherSpecify } from "@cartographerio/topo-form";
import { Result } from "@cartographerio/fp";
import { isPoint, safePointToNgr, } from "@cartographerio/geometry";
import { hasKey, hasOptionalKey, isArrayOf, isBoolean, isNullable, isNumber, isObject, isString, } from "@cartographerio/guard";
import { ArrtWaterQualityBankVegetationEnum, ArrtWaterQualityChannelSubstrateEnum, ArrtWaterQualityFlowConditionsEnum, ArrtWaterQualityFlowObstacleEnum, ArrtWaterQualityInvasivePlantEnum, ArrtWaterQualityLandUseEnum, ArrtWaterQualityNitrateEnum, ArrtWaterQualityPollutionEvidenceEnum, ArrtWaterQualityPollutionSourceEnum, ArrtWaterQualityRainfallEnum, ArrtWaterQualityWaterbodyTypeEnum, ArrtWaterQualityWaterLevelEnum, ArrtWaterQualityWildlifeEnum, } from "@cartographerio/inventory-enums";
import { isAttachmentFolder, isTimestamp, } from "@cartographerio/types";
export function isPartialData(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "recorded", isNullable(isTimestamp)) &&
        hasKey(data, "details", (details) => isObject(details) &&
            hasOptionalKey(details, "river", isNullable(isString)) &&
            hasOptionalKey(details, "site", isNullable(isString)) &&
            hasOptionalKey(details, "location", isNullable(isPoint)) &&
            hasKey(details, "waterbodyType", isOtherSpecify(isNullable(ArrtWaterQualityWaterbodyTypeEnum.isValue))) &&
            hasOptionalKey(details, "recentRain", isNullable(ArrtWaterQualityRainfallEnum.isValue)) &&
            hasKey(details, "photographs", isAttachmentFolder)) &&
        hasKey(data, "ecosystem", (ecosystem) => isObject(ecosystem) &&
            hasKey(ecosystem, "landUse", isOtherSpecify(isArrayOf(ArrtWaterQualityLandUseEnum.isValue))) &&
            hasKey(ecosystem, "bankVegetation", isOtherSpecify(isArrayOf(ArrtWaterQualityBankVegetationEnum.isValue))) &&
            hasKey(ecosystem, "invasivePlants", isOtherSpecify(isArrayOf(ArrtWaterQualityInvasivePlantEnum.isValue))) &&
            hasKey(ecosystem, "wildlife", isOtherSpecify(isArrayOf(ArrtWaterQualityWildlifeEnum.isValue)))) &&
        hasKey(data, "pollution", (pollution) => isObject(pollution) &&
            hasKey(pollution, "pollutionSources", isOtherSpecify(isArrayOf(ArrtWaterQualityPollutionSourceEnum.isValue))) &&
            hasKey(pollution, "pollutionEvidence", isOtherSpecify(isArrayOf(ArrtWaterQualityPollutionEvidenceEnum.isValue)))) &&
        hasKey(data, "riverChannel", (riverChannel) => isObject(riverChannel) &&
            hasOptionalKey(riverChannel, "estimatedWidth", isNullable(isNumber)) &&
            hasOptionalKey(riverChannel, "estimatedDepth", isNullable(isNumber)) &&
            hasKey(riverChannel, "dominantSubstrate", isOtherSpecify(isNullable(ArrtWaterQualityChannelSubstrateEnum.isValue))) &&
            hasOptionalKey(riverChannel, "flowConditions", isNullable(ArrtWaterQualityFlowConditionsEnum.isValue)) &&
            hasOptionalKey(riverChannel, "waterLevel", isNullable(ArrtWaterQualityWaterLevelEnum.isValue)) &&
            hasKey(riverChannel, "obstacles", isArrayOf(ArrtWaterQualityFlowObstacleEnum.isValue)) &&
            hasOptionalKey(riverChannel, "sampleTaken", isNullable(isBoolean)) &&
            hasOptionalKey(riverChannel, "temperature", isNullable(isNumber)) &&
            hasOptionalKey(riverChannel, "dissolvedSolids", isNullable(isNumber)) &&
            hasOptionalKey(riverChannel, "phosphate", isNullable(isNumber)) &&
            hasOptionalKey(riverChannel, "turbidity", isNullable(isNumber)) &&
            hasOptionalKey(riverChannel, "nitrate", isNullable(ArrtWaterQualityNitrateEnum.isValue))) &&
        hasOptionalKey(data, "notes", isNullable(isString)));
}
export function dataDescription(data) {
    return Result.guard(isPartialData, "PartialArrtWaterQualityData")(data).map(data => [
        data.details.river ?? "Unknown River",
        data.details.site ?? "Unknown Site",
        data.details.location
            ? safePointToNgr(data.details.location)
            : "Unknown NGR",
    ].join(", "));
}
export function dataGeometry(data) {
    return Result.guard(isPartialData, "PartialArrtWaterQualityData")(data).map(data => data.details.location ?? null);
}
export function dataTimestamp(data) {
    return Result.guard(isPartialData, "PartialArrtWaterQualityData")(data).map(data => data.recorded ?? null);
}
const emptyArrayOtherSpecify = { selected: [], other: null };
export function copyData(data) {
    return Result.guard(isPartialData, "PartialArrtWaterQualityData")(data).map(data => ({
        recorded: null,
        details: {
            ...data.details,
            recentRain: null,
        },
        ecosystem: {
            ...data.ecosystem,
            wildlife: emptyArrayOtherSpecify,
            invasivePlants: emptyArrayOtherSpecify,
        },
        pollution: {
            ...data.pollution,
            pollutionSources: emptyArrayOtherSpecify,
            pollutionEvidence: emptyArrayOtherSpecify,
        },
        riverChannel: {
            ...data.riverChannel,
            flowConditions: null,
            waterLevel: null,
            obstacles: [],
            sampleTaken: null,
            temperature: null,
            dissolvedSolids: null,
            phosphate: null,
            turbidity: null,
            nitrate: null,
        },
        notes: null,
    }));
}
//# sourceMappingURL=parts.js.map